SupportDefaultStatusAndNotesPresentation =
	egift:
		status: 'Purchased as a gift'
		notes: "This gift voucher has been sent via email—you cannot resend this gift via My Groupons. If the recipient didn't receive the email, you can still print the voucher from My Groupons and send it to them. <a href='/faq#gifts'> See more information on gifts</a>"
	gdt:
		un_redeemed:
			status: "Ready to use"
			notes: "To use your Groupon, click \"Order Food\"."
		redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""
	printed_gift:
		status: 'Purchased as a gift'
		notes: "You cannot resend this gift via My Groupons. If you still need to send the gift to the recipient, you can print the voucher from My Groupons and send it to them. <a href='/faq#gifts'> See more information on gifts</a>"
	editable:
		pending:
			status: "Processing"
			notes: "Your credit card will be charged within 24 hours. We'll send a confirmation email with your order details as soon as we process the transaction."
		failed:
			status: "Problem charging your credit card"
			notes: "We weren’t able to complete this transaction using the credit card you provided. Please edit your payment information to receive your Groupon voucher."
		refunded:
			status: "Refunded"
			notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
		refund_pending:
			status: "Refund Pending"
			notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
	not_editable:
		pending:
			status: "Processing"
			notes: "Your credit card will be charged within 24 hours. We'll send a confirmation email with your order details as soon as we process the transaction."
		failed:
			status: "Problem charging your credit card"
			notes: "We weren’t able to complete this transaction using the credit card you provided. Please edit your payment information to receive your Groupon voucher."
		refunded:
			status: "Refunded"
			notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
		refund_pending:
			status: "Refund Pending"
			notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."

module.exports = SupportDefaultStatusAndNotesPresentation
